if (!customElements.get('wholesale-order-item')) {
  class WholesaleOrderItem extends HTMLElement {
    constructor() {
      super();
      this.inputs = [...this.querySelectorAll('input[name="quantity"]')];
      this.total = this.querySelector('[data-total]');
      this.weight = this.querySelector('[data-weight]');
      this.onQuantityChange = this.onQuantityChange.bind(this); // bind once
      this.wholesaleForm = this.closest('wholesale-order-form');
      this.favoriteButton = this.querySelector('[data-favorite]');
    }

    connectedCallback() {
      this.inputs.forEach(input => {
        input.addEventListener('change',this.onQuantityChange);
      });
      if (this.favoriteButton) {
        this.syncFavoriteButton(); // <— set initial active state from localStorage
        this.favoriteButton.addEventListener('click', this.onFavoriteToggle.bind(this));
      }
    }

    readFavorites() {
      try {
        const raw = localStorage.getItem('favorites') || '[]';
        const arr = JSON.parse(raw);
        return Array.isArray(arr) ? arr.map(String) : [];
      } catch {
        return [];
      }
    }

     writeFavorites(ids) {
      const uniq = Array.from(new Set(ids.map(String)));
      localStorage.setItem('favorites', JSON.stringify(uniq));
    }

    syncFavoriteButton() {
      const productID = String(this.dataset.item || '');
      if (!productID || !this.favoriteButton) return;
      const favorites = this.readFavorites();
      const isFav = favorites.includes(productID);
      this.favoriteButton.classList.toggle('active', isFav);
      this.favoriteButton.setAttribute('aria-pressed', String(isFav));
      this.favoriteButton.setAttribute('title', isFav ? 'Remove from favorites' : 'Add to favorites');
    }

    onFavoriteToggle(e) {
      e.preventDefault();
      e.stopPropagation();

      const productID = String(this.dataset.item || '');
      if (!productID || !this.favoriteButton) return;

      const favorites = this.readFavorites();
      const isFav = this.favoriteButton.classList.contains('active');

      // Update favorites list
      const next = isFav ? favorites.filter(id => id !== productID) : [...favorites, productID];
      this.writeFavorites(next);

      // Reflect UI
      this.favoriteButton.classList.toggle('active', !isFav);
      this.favoriteButton.setAttribute('aria-pressed', String(!isFav));
      this.favoriteButton.setAttribute('title', !isFav ? 'Remove from favorites' : 'Add to favorites');

      // Optional: tell the form something changed (in case you want to re-sort live)
      this.dispatchEvent(new CustomEvent('favorite:toggle', { bubbles: true, detail: { productID, isFav: !isFav } }));
    }

    onQuantityChange() {
      let totalWeight = 0;
      let totalPriceCents = 0;
      const activeInputs = this.inputs.filter(input => input.value > 0);
      activeInputs.forEach(input => {
        const quantity = parseInt(input.value, 10) || 0;
        // weight like "45lb" or "45 lb"
        const size = input.getAttribute('data-size') || '';
        const weight = size ? parseFloat(size.replace(/lb/i, '').trim()) : 0;
        totalWeight += quantity * weight;

        // price stored in cents
        const priceCents = parseInt(input.getAttribute('data-price'), 10) || 0;
        totalPriceCents += quantity * priceCents;
        });

        const totalPrice = (totalPriceCents / 100).toFixed(2);
        if(!this.weight || !this.total) {
          console.error('Totals elements not found');
          return;
        }
        this.weight.dataset.weight = totalWeight
        this.total.dataset.total = totalPriceCents;
        this.total.textContent = "$" + totalPrice;
        this.weight.textContent = totalWeight.toFixed(2) + ' lb';
        this.dataset.active = activeInputs.length > 0 ? 'true' : 'false';
        if( this.wholesaleForm ){
            this.wholesaleForm.updateTotals();
        }
    }
  }

  customElements.define('wholesale-order-item', WholesaleOrderItem);
}


if (!customElements.get('wholesale-order-form')) {
     // Simple debounce helper
  function debounce(fn, wait = 250) {
    let t;
    return function (...args) {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  class WholesaleOrderForm extends HTMLElement {
    constructor() {
        super();
        this.searchInput = this.querySelector('[data-search]');
        this.addToCartButtons = this.querySelectorAll('[data-submit]');
        this.categoryFilter = this.querySelector('[data-collection-filter]');
        this.items = [];
        this.handleInput = this.handleInput.bind(this);
        this.handleInputDebounced = debounce(this.handleInput, 250);
        this.totalWeights = this.querySelectorAll('[data-total-weight]');
        this.totalPrices = this.querySelectorAll('[data-total-price]');
        this.endpoint = 'https://yakimavalleyhops.myshopify.com/api/2025-10/graphql.json'; 
        this.token = '84ac706d35e63d3763dd93c8be746013'; 
        this.products = [];
        this.onSubmitClick = this.onSubmitClick.bind(this);
        this.cartDrawer = document.querySelector('cart-drawer');
    }
    connectedCallback() {
     if (this.searchInput) {
        this.searchInput.addEventListener('input', this.handleInputDebounced);
        this.searchInput.addEventListener('keydown', this.handleKeydown);
      }

      if(this.categoryFilter){
        this.categoryFilter.addEventListener('change', this.onCategoryChange.bind(this));
      }
      if (this.addToCartButtons?.length) {
        this.addToCartButtons.forEach(btn => {
          btn.addEventListener('click', this.onSubmitClick);
        });
      }
      this.fetchAllProducts();
    }

    buildCartItems() {
      const inputs = [...this.querySelectorAll('input.qty-input__input[data-vid]')];
      // Merge duplicates by id
      const map = new Map(); // id -> qty
      inputs.forEach(input => {
        const qty = parseInt(input.value, 10) || 0;
        if (qty <= 0) return;
        const idStr = input.getAttribute('data-vid');
        if (!idStr) return;
        const id = Number(idStr);
        if (!Number.isFinite(id)) return;

        map.set(id, (map.get(id) || 0) + qty);
      });

      return [...map.entries()].map(([id, quantity]) => ({ id, quantity }));
    }

    async addToCart(items, button) {
      if (!items.length) {
        console.warn('No items selected to add to cart');
        return;
      }
      items.forEach((item) => {
        item['properties']  = {'_yakima_opo' : true}
      })

    try {
        if (button) {
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
        }

        let sections = 'cart-icon-bubble';
        if (this.cartDrawer) {
          sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
        }
        const body = {
          sections,
          items 
        }

        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        });

        if (!res.ok) {
          const text = await res.text().catch(() => '');
          throw new Error(`Cart add failed (${res.status}): ${text}`);
        }

        const data = await res.json();
        setTimeout(() => {
            // Update cart drawer contents.
            if (this.cartDrawer) {
              this.cartDrawer.renderContents(
                data,
                theme.settings.afterAtc === 'drawer'
              );
            } else if (window.location.pathname === theme.routes.cart) {
              const cartItems = document.querySelector('cart-items');
              if (cartItems) {
                if (cartItems.dataset.empty === 'true') {
                  window.location.reload();
                } else {
                  cartItems.refresh();
                }
              }
            }
          }, 700);
        // Optional: dispatch a custom event for drawers etc.
        //this.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: data }));

        // Clear all inputs back to 0 and recalc totals
        this.querySelectorAll('input.qty-input__input[data-vid]').forEach(input => {
          input.value = 0;
          // Trigger any per-item recompute if needed
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
        this.updateTotals();

      } catch (err) {
        console.error(err);
        // Optional: show a UI message
        alert('Sorry, we could not add those items to your cart.');
      } finally {
        if (button) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      }
    }

    onSubmitClick(e) {
      e.preventDefault();
      const button = e.currentTarget;
      const items = this.buildCartItems();
      this.addToCart(items, button);
    }

    readFavorites() {
      try {
        const raw = localStorage.getItem('favorites') || '[]';
        const arr = JSON.parse(raw);
        return Array.isArray(arr) ? arr.map(String) : [];
      } catch {
        return [];
      }
    }

    sortProductsByFavorites(products) {
      const favs = new Set(this.readFavorites());
      // Favorites first, keep relative order otherwise
      return [...products].sort((a, b) => {
        const aID = a.id.replace("gid://shopify/Product/", "");
        const bID = b.id.replace("gid://shopify/Product/", "");
        const aFav = favs.has(String(aID));
        const bFav = favs.has(String(bID));
        if (aFav === bFav) return 0;
        return aFav ? -1 : 1;
      });
    }

    refreshItems() {
      this.items = [...this.querySelectorAll('wholesale-order-item')];
    }

    formatMoney(price) {
      const amount = Number(price?.amount ?? 0);
      const currency = price?.currencyCode || 'USD';
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(amount);
      } catch {
        return `$${amount.toFixed(2)}`;
      }
    }

    extractSize(variant) {
      const optLb = (variant.selectedOptions || []).find(o => /\blb\b/i.test(o.value || ''));
      if (optLb) return optLb.value;
      const optSize = (variant.selectedOptions || []).find(o => /size/i.test(o.name || ''));
      return optSize ? optSize.value : (variant.selectedOptions?.[0]?.value || '');
    }

    // ---- Data fetch ----
    async fetchAllProducts() {
      const query = `
        query {
          collection(id:"gid://shopify/Collection/264493793413"){
            products(first:250){
              edges{
                node{
                  id
                  title
                  availableForSale
                  featuredImage{ id url altText }
                  collections(first:20){ edges{ node{ 
                    title
                    handle
                  } } }
                  variants(first:250){
                    edges{
                      node{
                        id
                        title
                        availableForSale
                        quantityAvailable
                        selectedOptions{ name value }
                        price{ amount currencyCode }
                        quantityRule{ maximum }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      `;

      const response = await fetch(this.endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': this.token,
        },
        body: JSON.stringify({ query }),
      });

      const result = await response.json();
      const data = result?.data?.collection?.products;
      const products = data?.edges?.map(edge => edge.node) || [];
      this.products = this.sortProductsByFavorites(products);
      this.renderProductHTML();
    }

    matchesWholesaleSize(value) {
      // Accept: 11lb, 11 lbs, 11lbs, 22lb, 22 lbs, 22lbs (case-insensitive)
      return /^(11|22)\s*lb?s?$/i.test(String(value || '').trim());
    }

   
renderProductHTML() {
  const container = this.querySelector('[data-products]');
  const itemTpl = document.querySelector('template[data-item-template]');
  const variantTpl = document.querySelector('template[data-variant-item-template]');
  const pppTpl = document.querySelector('template[data-ppp-item-template]');
  if (!container || !itemTpl || !variantTpl || !pppTpl) {
    console.error('Missing [data-products] or templates');
    return;
  }

  const df = document.createDocumentFragment();

  for (const product of this.products) {
    // All variants
    const allVariants = (product.variants?.edges || []).map(e => e.node);

    // Keep only variants where selectedOptions has name "Size" and value matches 11/22 lb(s)
    const filteredVariants = allVariants.filter(v => {
      const sizeOpt = (v.selectedOptions || []).find(o => /size/i.test(o.name || ''));
      return sizeOpt ? this.matchesWholesaleSize(sizeOpt.value) : false;
    });
    console.log(filteredVariants)
    // Skip the whole product if none of its variants match or has no available stock
    if (!filteredVariants.length || filteredVariants.filter((f) => f.availableForSale).length === 0) continue;

    // Clone the product template
    const frag = itemTpl.content.cloneNode(true);

    // Root & attrs
    const root = frag.querySelector('wholesale-order-item');
    if (root) {
      const id = product.id.replace("gid://shopify/Product/", "");
      root.setAttribute('data-item', id);
      root.setAttribute('data-title', product.title || '');
      // NEW: store collection handles for category filtering
      const handles = (product.collections?.edges || [])
        .map(e => e?.node?.handle)
        .filter(Boolean);
      root.dataset.collections = handles.join(',');
    }

    // Title
    frag.querySelectorAll('.item__label').forEach(el => (el.textContent = product.title || ''));

    // Image
    const img = frag.querySelector('img[src="PRODUCT_IMAGE_URL"]');
    if (img) {
      if (product.featuredImage?.url) img.src = product.featuredImage.url;
      img.alt = product.featuredImage?.altText || product.title || '';
      img.width = 60;
      img.height = 60;
    }

    // Variants host
    const variantsHost = frag.querySelector('[data-variants]');
    const pppFrag = pppTpl.content.cloneNode(true);
    variantsHost.appendChild(pppFrag);
    filteredVariants.forEach(v => {
      if(v.availableForSale === false) return; // skip OOS variants
      const vid = v.id.replace("gid://shopify/ProductVariant/", "");
      const vFrag = variantTpl.content.cloneNode(true);

      // Root attrs
      const vRoot = vFrag.querySelector('[data-variant]');
      if (vRoot) {
        vRoot.setAttribute('data-variant', vid);
        vRoot.setAttribute('data-available', String(!!v.availableForSale));
      }

      // Title
      const titleNode = vFrag.querySelector('.text-sm'); // first .text-sm in row is the title
      if (titleNode) titleNode.textContent = v.title || '';

      // Price
      const priceNode = vFrag.querySelector('.text-sm.font-bold');
      if (priceNode) priceNode.textContent = this.formatMoney(v.price);

      // Qty / OOS toggling
      const qtyInput = vFrag.querySelector('input[name="quantity"]');
      const qtyWrap = vFrag.querySelector('quantity-input');
      const oosEl = vFrag.querySelector('[data-oos]');

      if (v.availableForSale) {
        const cents = Math.round(Number(v.price?.amount || 0) * 100);

        if (qtyInput) {
          qtyInput.dataset.vid = vid;
          qtyInput.value = '0';
          qtyInput.setAttribute('data-price', String(cents));

          // Keep the size value in data-size (taken from selectedOptions)
          const sizeOpt = (v.selectedOptions || []).find(o => /size/i.test(o.name || ''));
          qtyInput.setAttribute('data-size', sizeOpt?.value || '');

          if (typeof v.quantityAvailable === 'number' && v.quantityAvailable >= 0) {
            qtyInput.setAttribute('max', String(v.quantityAvailable));
          } else {
            qtyInput.removeAttribute('max');
          }
        }
        if (oosEl) oosEl.style.display = 'none';
        if (qtyWrap) qtyWrap.style.display = '';
      } else {
        if (qtyWrap) qtyWrap.style.display = 'none';
        if (oosEl) oosEl.style.display = '';
      }
      //PPP
      if(v.title.includes('11lb')){
        const pppEl = vFrag.querySelector('[data-11-ppp]')
        const pppEl44 = vFrag.querySelector('[data-44-ppp]')
        const pppEl440 = vFrag.querySelector('[data-440-ppp]')
        if(pppEl && pppEl44 && pppEl440) {
          const ppp = (Number(v.price.amount || 0) / 11).toFixed(2);
          pppEl.textContent = "$" + ppp + "/lb";
          pppEl44.textContent = "$" + (ppp * .95).toFixed(2) + "/lb";
          pppEl440.textContent = "$" + (ppp * .90).toFixed(2) + "/lb";
        }
      }

      // Update any remaining placeholder attributes referencing VARIANT_ID
      const labelFor = vFrag.querySelector('label[for="VARIANT_ID"]');
      if (labelFor) labelFor.setAttribute('for', vid);

      variantsHost.appendChild(vFrag);
    });

    df.appendChild(frag);
  }

  // Inject built DOM
  container.innerHTML = '';
  container.appendChild(df);

  // Update internal cache & totals
  this.refreshItems();
  this.updateTotals?.();
}

    handleKeydown(e) {
      // Clear on ESC and show all
      if (e.key === 'Escape') {
        this.searchInput.value = '';
        this.filterItems('');
      }
    }

    handleInput() {
      this.activeQuery = (this.searchInput?.value || '').trim().toLowerCase();
      this.applyFilters();
    }

     onCategoryChange() {
      const selectedCategory = (this.categoryFilter?.value || '').trim().toLowerCase();
      this.activeCategory = selectedCategory; // e.g. "floral" (collection handle) or "" / "all"
      this.applyFilters();
      // const hasCat = selectedCategory !== '';
      // this.items.forEach((el) => {
      //   const raw = (el.dataset.collections || '').toLowerCase(); // "floral,citrus,all-hops"
      //   const list = raw ? raw.split(',') : [];
      //   const matchesCategory = !hasCat || list.includes(selectedCategory);
      //   el.style.display = (matchesCategory) ? '' : 'none';
      // });
    }

    applyFilters() {
      const q = this.activeQuery;
      const cat = this.activeCategory;

      // Treat empty/“all” as no category filter
      const hasCat = cat && cat !== '';

      this.items.forEach((el) => {
        // title match (existing search)
        const title = (el.getAttribute('data-title') || '').toLowerCase();
        const matchesQuery = !q || title.includes(q);

        // category match
        const raw = (el.dataset.collections || '').toLowerCase(); // "floral,citrus,all-hops"
        const list = raw ? raw.split(',') : [];
        const matchesCategory = !hasCat || list.includes(cat);

        el.style.display = (matchesQuery && matchesCategory) ? '' : 'none';
      });
    }

    filterItems(query) {
      // Show everything if query is empty
      if (!query) {
        this.items.forEach((el) => (el.style.display = ''));
        return;
      }

      this.items.forEach((el) => {
            const title = (el.getAttribute('data-title') || '').toLowerCase();
            const match = title.includes(query);
            el.style.display = match ? '' : 'none';
        });
    }

    updateTotals() {
      const totalWeight = this.items.reduce((sum, item) => {
        const weight = parseFloat(item.weight.dataset.weight) || 0;
        return sum + weight;
      }, 0);
      this.totalWeights.forEach(el => {
        el.textContent = totalWeight.toFixed(2) + ' lb';
      });

      
      const totalPriceCents = this.items.reduce((sum, item) => {
        const price = parseInt(item.total.dataset.total, 10) || 0;
        return sum + price;
      }, 0);
      const totalPrice = (totalPriceCents / 100).toFixed(2);
      this.totalPrices.forEach(el => {
        el.textContent = "$" + totalPrice;
      });
      
    }

  }

  customElements.define('wholesale-order-form', WholesaleOrderForm);
}


